import type { Post_TPostId } from '../Post/Post.TPost'
import { Rout_create } from './Rout.create'
import { Rout_replace, Rout_to } from './Rout'
import { Rout_setBack } from './Rout.back'
import type { Target } from '../../../shared/domain/posts/types.no-deps'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'
import type { FlowContinuationId } from '../../../app-core/lib/flow/FlowReport'

export interface Rout_PostRoutesArgs {
    Post_TextPostFormNew: React.FunctionComponent<unknown>
    Post_TextPostFormEdit: React.FunctionComponent<unknown>
    Post_DetailPage: React.FunctionComponent<unknown>
}

export const Rout_PostRoutes = (args: Rout_PostRoutesArgs) => [
    Rout_create('/post/text/new', args.Post_TextPostFormNew),
    Rout_create('/post/text/edit/:postId', args.Post_TextPostFormEdit),
    Rout_create('/post/:postId', args.Post_DetailPage),
]

export function Rout_toPost(
    postId: Post_TPostId,
    back: () => void,
    opts?: {
        comingFromActionScheduledInstance?: boolean
        comingFromScheduledInstance?: UUID
        comingFromUnit?: number
        comingFromWorkflow?: number
        markNotficationsAsRead?: boolean
        notificationScheduleId?: UUID
        notificationPostEventId?: UUID
        notificationPostCommentId?: UUID
        notificationId?: UUID
        previousReport?: FlowContinuationId
    }
) {
    Rout_setBack(back)
    Rout_to(`/post/${postId}`, opts)
}

export function Rout_replacePost(
    postId: Post_TPostId,
    back: () => void,
    opts?: { markNotficationsAsRead?: boolean; previousReport?: FlowContinuationId }
) {
    Rout_setBack(back)
    Rout_replace(`/post/${postId}`, opts)
}

export function Rout_replaceWithPost(postId: Post_TPostId) {
    Rout_replace(`/post/${postId}`)
}

export function Rout_toTextPostNew(target: Target) {
    Rout_to(`/post/text/new`, target)
}

export function Rout_toTextPostEdit(postId: Post_TPostId) {
    Rout_to(`/post/text/edit/${postId}`)
}
